<template>
  <div class="upload-less">
    <el-upload
      drag
      :action="uploadUrl"
      :on-success="onSuccess"
      :on-remove="onRemove"
      :before-upload="beforeUpload"
      multiple
    >
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + "/api/questionnaire/upload/file"
    };
  },
  methods: {
    onSuccess(response, file, fileList) {
      if (fileList.length !== 0) {
        const files = fileList
          .filter(
            x => x.status === "success" && x.response.status === "Success"
          )
          .map(x => x.response.msg);
        this.$emit("input", files);
      }
    },
    onRemove(file, fileList) {
      const files = fileList
        .filter(x => x.response.status === "Success")
        .map(x => x.response.msg);
      this.$emit("input", files);
    },
    beforeUpload(file) {
      let type = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(type);
      // if (type === "doc" || type === "docx" || type === "pdf") {
      //   return true;
      // } else {
      //   this.$message.error("仅支持word和pdf格式的文档");
      // }
      return true;
    }
  }
};
</script>

<style>
.upload-less {
  width: 100%;
}
.upload-less .el-upload {
  display: inherit;
}
.upload-less .el-upload-dragger {
  height: 50px;
  width: 100%;
}
</style>
